import request from '@/utils/request'

/** 通用的上传文件接口 */
export function uploadFile(data: AnyObject) {
  const form = new FormData()
  Object.keys(data).forEach((key) => {
    form.append(key, data[key])
  })
  return request<{
    code: number
    fileName: string
    originalFilename: string
    newFileName: string
  }>({
    url: '/common/visitor/upload',
    method: 'post',
    data: form,
  })
}

/** 游客模式的字典查询 */
export const getDict = (dictType: string) => {
  return request<{ data: { dictLabel: string; dictValue: string }[] }>({
    url: `/web/type/${dictType}`,
    method: 'get',
  })
}
